import { defineMessages } from 'react-intl';
import { InsuranceProviders } from '../../../enums/insurance-providers';

export const disclaimerMessages = defineMessages({
  [InsuranceProviders.Shipsurance.insuranceProviderId]: {
    description: 'shipsuranceTerms',
    defaultMessage:
      '<helpArticleLink>Learn more</helpArticleLink> about Shipsurance. By creating this label you agree to the <a>coverage terms</a>.',
    id: 'MIp8/W',
  },
  [InsuranceProviders.XCover.insuranceProviderId]: {
    description: 'cta for XCover terms and conditions',
    defaultMessage: 'View <a>coverage terms</a> and <helpArticleLink>learn more</helpArticleLink> about Total Shipping Protection.',
    id: '46raeJ',
  },
  [InsuranceProviders.ParcelGuard.insuranceProviderId]: {
    description: 'cta for ParcelGuard terms and conditions',
    defaultMessage: 'Learn about <popover>ParcelGuard terms and coverage</popover>.',
    id: 'HfQY48',
  },
});

export const parcelGuardTooltipMessages = defineMessages({
  about: {
    defaultMessage: 'About ParcelGuard',
    id: 'v1pvg3',
    description: 'title for tooltip',
  },
  body: {
    defaultMessage:
      'With ParcelGuard coverage, you can insure almost anything up to $10,000.00 sent almost anywhere in the world. <helpArticleLink>Learn more about ParcelGuard</helpArticleLink> and their <termsLink>coverage terms</termsLink> to ensure a shipment is eligible.',
    id: 'S+kGTz',
    description: 'info for the body of the tooltip offering details about parcelguard',
  },
  disclaimer: {
    defaultMessage: 'ParcelGuard is underwitten by Amercian Bankers Insurance Company of Florida and is adminstered by Shipsurance, Inc.',
    id: 'D45utm',
    description: 'disclaimer for the tooltip offering legalese details',
  },
});
